import { createRoot } from 'react-dom/client';
import { App } from './app/App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(<App />);

/* Lets the kiosk be added to the iPad home screen and launch without Safari's
   chrome. Dev builds skip it so Vite's hot reload is never served from a cache. */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
